'use client';

import { default as ErrorNested } from '@/modules/shared/ui/router-feedback/error';

export default function Error() {
  return <ErrorNested />;
}
